const initialState = {
  overviewSummary: {
    averageBuses: 0,
    totalCollection: 0,
    operatorPayout: 0,
    balanceLoaded: 0,
    moneyLoadedBreakdown: {
      totalRechargeCardSold: 0,
      totalPassIssueCashAmt: 0,
      cardFee: 0,
    },
    walletUsage: 0,
    digitalConsumtionBreakdown: {
      ticketByPrepaidCard: 0,
      mobileTicketAmount: 0,
      passIssueProductCost: 0,
      chaloPayAmount: 0,
      ncmcPrepaidAmount: 0,
      scanPayAmount: 0,
      upiTicketAmount: 0,
      mobileTicketResidualAmount: 0,
    },
    epkm: 0,
    totalPassengerCount: 0,
    digitalPenetration: {
      Amount: 0,
      Ridership: 0,
    },
    ridership: {
      totalRidership: 0,
      digitalRidership: 0,
    },
    digitalMeta: {
      cardsSold: 0,
      passesSold: 0,
      rechargesDone: 0,
    },
    mobileProducts: {
      mobileTicketsSold: 0,
      mobilePassesSold: 0,
      mobileRechargesDone: 0,
    },
    exitBuses: 0,
    totalGpsDistance: 0,
    digitalDiscountByChalo: 0,
    ticketSalesAmount: 0,
    passSalesAmount: 0,
    onlineRecharge: 0,
  },
  gcOverview: {
    finalProfit: 0,
    finalProfitBreakDown: {
      contractualAmount: 0,
      convenienceFee: 0,
      cardFee: 0,
    },
  },
  financialOverview: {
    amountSettled: {
      amountPaid: 0,
      amountReceived: 0,
    },
    currentOutstanding: {
      toBePaid: 0,
      toBeReceived: 0,
    },
  },
};
export default initialState;
